import React from 'react';
import '../style/layout.less';
import AdminHeader from './header';
import {useOutlet} from "react-router-dom";
import KeepAlive from './keepAlive'

const Layout = () => {
    const outlet = useOutlet();
    return (
        <div className="layout">
            <AdminHeader/>
            <div className="layout-main">
                <KeepAlive include={ ['/index'] } keys={ {} }>
                    { outlet }
                </KeepAlive>
            </div>
        </div>
    )
}

export default Layout;
